import axios from 'axios';
import { postData } from '../axiosUtils';

const emailtemplateService = {
  list: () => {
    return axios.get(`/api/emailTemplate/list`).then((response) => {
      return response.data;
    });
  },
  get: (id: any) => {
    return axios.get(`/api/emailTemplate/details/${id}`).then((response) => {
      return response.data;
    });
  },
  create: (entity: any) => {
    return postData({
      url: `/api/emailTemplate/create`,
      data: entity,
    }).then((response) => {
      return response;
    });
  },
  update: (entity: any) => {
    return postData({
      url: `/api/emailTemplate/update`,
      data: entity,
      method: 'PUT',
    }).then((response) => {
      return response;
    });
  },
  setDefault: (id: any) => {
    return postData({
      url: `/api/emailTemplate/setDefault/${id}`,
      method: 'PUT',
    }).then((response) => {
      return response;
    });
  },
  delete: (id: any) => {
    return postData({
      url: `/api/emailTemplate/delete/${id}`,
      method: 'DELETE',
    }).then((response) => {
      return response;
    });
  },
};

export default emailtemplateService;
